import { useState } from 'react'
import { 
  Page, 
  Card, 
  FormLayout, 
  TextField, 
  Button, 
  Layout,
  Text,
  Link
} from '@shopify/polaris'
import { useAuth } from '@/contexts/AuthContext'

export default function LoginPage() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    storeId: ''
  })
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    
    try {
      await login(formData.email, formData.password, formData.storeId)
    } catch (error) {
      // Error is handled in AuthContext
    } finally {
      setLoading(false)
    }
  }

  const handleInputChange = (field: string) => (value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }))
  }

  return (
    <Page>
      <Layout>
        <Layout.Section>
          <div style={{ 
            maxWidth: '400px', 
            margin: '0 auto', 
            paddingTop: '100px' 
          }}>
            <Card>
              <div style={{ padding: '24px' }}>
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                  <Text variant="headingLg" as="h1">
                    WhatsApp CRM
                  </Text>
                  <Text variant="bodyMd" as="p" color="subdued">
                    Sign in to your account
                  </Text>
                </div>

                <form onSubmit={handleSubmit}>
                  <FormLayout>
                    <TextField
                      label="Store ID (optional)"
                      value={formData.storeId}
                      onChange={handleInputChange('storeId')}
                      placeholder="Leave blank to see all your workspaces"
                      autoComplete="organization"
                    />

                    <TextField
                      label="Email"
                      type="email"
                      value={formData.email}
                      onChange={handleInputChange('email')}
                      placeholder="Enter your email"
                      autoComplete="email"
                      required
                    />
                    
                    <TextField
                      label="Password"
                      type="password"
                      value={formData.password}
                      onChange={handleInputChange('password')}
                      placeholder="Enter your password"
                      autoComplete="current-password"
                      required
                    />
                    
                    <Button
                      submit
                      primary
                      fullWidth
                      loading={loading}
                      disabled={!formData.email || !formData.password}
                    >
                      Sign In
                    </Button>
                  </FormLayout>
                </form>

                <div style={{ 
                  textAlign: 'center', 
                  marginTop: '24px',
                  paddingTop: '24px',
                  borderTop: '1px solid #e1e3e5'
                }}>
                  <Text variant="bodyMd" as="p" color="subdued">
                    Don't have an account?{' '}
                    <Link url="/signup">Create a workspace</Link>
                  </Text>
                </div>
              </div>
            </Card>
          </div>
        </Layout.Section>
      </Layout>
    </Page>
  )
}